<template>
  <div class="px-4 sm:px-6 py-5">
    <div class="space-y-6 sm:space-y-5">
      <div>
        <h3 class="text-lg leading-6 font-medium text-gray-900">General Settings</h3>
        <p class="mt-1 max-w-2xl text-sm text-gray-500">Setup sender and subject.</p>
      </div>

      <BaseFetchData :action="fetchEmailMessage">
        <template #default="fetchDataProps">
          <BaseVeeForm v-if="fetchDataProps.status.resolved" :action="updateEmailMessage">
            <template #default="formProps">
              <div class="space-y-8">
                <BaseFormTextFieldWithValidator
                  v-model="emailMessageData.subject"
                  v-bind="subjectFieldProps"
                  class="max-w-lg"
                  :disabled="!canUpdate || formProps.isPending"
                />

                <BaseFormSelectFieldWithValidator
                  v-model="emailMessageData.third_party_service_id"
                  v-bind="fromFieldProps"
                  :disabled="!canUpdate || formProps.isPending"
                />

                <BaseButton
                  primary
                  :disabled="!canUpdate || formProps.isPending || formProps.invalid"
                >
                  Save
                </BaseButton>
              </div>
            </template>
          </BaseVeeForm>
        </template>
      </BaseFetchData>
    </div>
  </div>
</template>

<script>
import { emailMessagesClient } from '@/api/clients';
import { uniqBy } from 'lodash-es';

export default {
  props: {
    emailCampaign: {
      type: Object,
      required: true,
    },
    canUpdate: Boolean,
  },
  data() {
    return {
      thirdPartyServiceOptions: [],
      emailMessageData: {
        subject: '',
        third_party_service_id: null,
      },
    };
  },
  computed: {
    subjectFieldProps() {
      return {
        validator: {
          vid: 'subject',
          name: 'subject',
          rules: {
            required: true,
          },
        },
        field: {
          id: 'email_message_subject',
          label: 'Subject',
        },
      };
    },
    fromFieldProps() {
      return {
        validator: {
          vid: 'third_party_service_id',
          name: 'from',
          rules: {
            required: true,
          },
        },
        field: {
          id: 'email_message_from',
          label: 'From',
          options: this.thirdPartyServiceOptions,
        },
      };
    },
  },
  methods: {
    async fetchEmailMessage() {
      try {
        const response = await emailMessagesClient.read(this.emailCampaign.email_message_id, {
          include: 'third_party_service,third_party_service_options',
        });

        this.emailMessageData = {
          subject: response.data.subject ?? '',
          third_party_service_id: response.data.third_party_service_id ?? null,
        };

        const allThirdPartyServiceOptions = uniqBy(
          [
            ...(response.data.third_party_service ? [response.data.third_party_service] : []),
            ...response.data.third_party_service_options,
          ],
          'id'
        );

        this.thirdPartyServiceOptions = allThirdPartyServiceOptions.map((option) => ({
          label: option.email_address,
          value: option.id,
        }));
      } catch (error) {
        //
      }
    },
    updateEmailMessage() {
      return emailMessagesClient.update(this.emailCampaign.email_message_id, this.emailMessageData);
    },
  },
};
</script>
